import { Component } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
    selector: "app-spinner",
    imports: [MatProgressSpinner],
    templateUrl: "./spinner.component.html",
})
export class SpinnerComponent {}
